import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Dialog } from '@headlessui/react';
import { ReactComponent as IconCalendar } from "assets/images/icons/project-icons/calendar-blank.svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import OnboardingTitle from 'components/__new/common/onboardingTitle';
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";


class GetStartedDemo extends Component {

    state = {
        showModalAssignToGroup: false,
    }

    toggleModalAssignToGroup = (action) => {
        this.setState({showModalAssignToGroup: action});
    }

    render() { 
        const {user: account} = this.props;
        const {showModalAssignToGroup} = this.state;

        return (
            <React.Fragment>


                <DynamicHeadTag headerText="Onboarding" />



                {(showModalAssignToGroup === true) &&
                    <Dialog open={showModalAssignToGroup} initialFocus={this.completeButtonRef} onClose={() => this.toggleModalAssignToGroup(false)} className="fixed z-10 inset-0 overflow-y-auto">
                        <div className="flex items-center justify-center min-h-screen">
                            <Dialog.Overlay className="fixed inset-0 bg-white bg-blur bg-opacity-50" />
                            {/* <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" /> */}

                            <div className="w-full max-w-lg mx-auto relative bg-white rounded overflow-hidden shadow-xl">
                                <div className="h-12 px-4 bg-ep-primary flex justify-between overflow-hidden">
                                    <div className="my-auto text-white">
                                        Schedule Appointment
                                    </div>
                                    <div onClick={() => this.toggleModalAssignToGroup(false)} ref={this.completeButtonRef} className="w-7 h-7 flex my-auto border group hover:bg-red-400 hover:border-red-400 border-white rounded-lg cursor-pointer">
                                        <FontAwesomeIcon icon="times" className="text-white m-auto" />
                                    </div>
                                </div>

                                <div className="p-6">
                                    <div className="border rounded-md bg-gray-200 overflow-hidden">
                                        <iframe src="https://calendly.com/earnipay-josh/30min" title="book demo" style={{width: "100%", height: "450px"}}></iframe>
                                    </div>

                                    <div className="mt-4">
                                        <button onClick={() => this.toggleModalAssignToGroup(false)} className="btn btn-transparent-black btn-block">Close</button>
                                    </div>
                                </div>
                                
                            </div>

                        </div>
                    </Dialog>
                }




                <div className="lg:flex">
                    <div className="w-full lg:w-1/2">
                        <div className="page-title">
                            Dashboard
                        </div>
                    </div>
                    <div className="w-full flex mt-2 lg:mt-0 lg:justify-end space-x-3 lg:w-1/2"></div>
                </div>
                
                <div className="mt-6 box">
                    <OnboardingTitle tab="demo" />
                </div>

                <div className="mt-2 box">
                    <div className="max-w-md mx-auto mt-4 mb-8">
                        <form onSubmit={this.submitFormLegal}>
                            <div className="">

                                <div className="form-group">
                                    <label>
                                        First Name
                                        <span className="form-input-required">*</span>
                                    </label>
                                    <input type="text" name="firstName" placeholder="Enter your First Name" className="form-input" value={account.firstName} disabled />
                                </div>

                                <div className="form-group">
                                    <label>
                                        Last Name
                                        <span className="form-input-required">*</span>
                                    </label>
                                    <input type="text" name="lastName" placeholder="Enter your Last Name" className="form-input" value={account.lastName} disabled />
                                </div>

                                <div className="form-group">
                                    <label>
                                        Email Address
                                        <span className="form-input-required">*</span>
                                    </label>
                                    <input type="text" placeholder="Enter your Email Address" className="form-input" value={account.email} disabled />
                                </div>
                                
                                <div className="form-group">
                                    <label>
                                        Date for demo
                                        {/* <span className="form-input-required">*</span> */}
                                    </label>
                                    <div className="form-input cursor-pointer" onClick={() => this.toggleModalAssignToGroup(true)}>
                                        <div className="flex space-x-0 pt-1">
                                            <IconCalendar className="customizeSVG sidebar-links-icon" />
                                            <span>
                                                Select date for demo
                                            </span>
                                        </div>
                                    </div>
                                </div>


                            </div>

                            <div className="mt-8 flex justify-between space-x-4">
                                <Link to="/get-started/info/financials" className="btn btn-lg btn-transparent-black btn-block">
                                    Skip
                                </Link>
                                <Link to="/get-started/info/financials" className="btn btn-lg btn-ep-primary btn-block">
                                    Continue
                                </Link>
                            </div>

                        </form>
                    </div>
                </div>

            </React.Fragment>

        );
    }
}
 

const mapStateToProps = (state) => ({
    user: state.auth.userPersist.data,
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(GetStartedDemo);